window.ElevenRetroCart = (function () {
  function refreshDrawer(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const freshInner = doc.querySelector('#CartDrawer .drawer__inner');
    const liveInner = document.querySelector('#CartDrawer .drawer__inner');
    if (freshInner && liveInner) {
      liveInner.innerHTML = freshInner.innerHTML;
    }
    const freshEmptyState = doc.querySelector('cart-drawer');
    const liveDrawer = document.querySelector('cart-drawer');
    if (freshEmptyState && liveDrawer) {
      liveDrawer.classList.toggle('is-empty', freshEmptyState.classList.contains('is-empty'));
    }
    document.dispatchEvent(new CustomEvent('eleven-retro:cart-refreshed'));
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.sections && data.sections['cart-drawer']) {
          refreshDrawer(data.sections['cart-drawer']);
        }
        return data;
      });
  }

  function add(variantId, quantity) {
    return request('/cart/add.js', {
      items: [{ id: variantId, quantity: quantity || 1 }],
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    });
  }

  function changeLine(variantIdOrKey, quantity) {
    return request('/cart/change.js', {
      id: variantIdOrKey,
      quantity: quantity,
      sections: ['cart-drawer'],
      sections_url: window.location.pathname,
    });
  }

  function toggleInsurance(btn) {
    if (btn.disabled) return;
    const variantId = btn.dataset.variantId;
    const isActive = btn.classList.contains('is-active');
    btn.disabled = true;
    btn.classList.add('is-loading');
    const done = () => {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    };
    if (isActive) {
      changeLine(variantId, 0).then(done).catch(done);
    } else {
      add(variantId, 1).then(done).catch(done);
    }
  }

  function upsellVariantChange(selectEl) {
    const card = selectEl.closest('.cart-upsell-item');
    if (!card) return;
    const dataEl = card.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const match = variants.find((v) => v.option1 === selectEl.value);
    if (match) {
      const addBtn = card.querySelector('.cart-upsell-item__add');
      const priceEl = card.querySelector('.cart-upsell-item__price');
      if (addBtn) addBtn.dataset.variantId = match.id;
      if (priceEl) priceEl.textContent = match.price;
    }
  }

  function upsellAdd(btn) {
    if (btn.disabled) return;
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '...';
    add(variantId, 1)
      .then(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      })
      .catch(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  return { add, changeLine, toggleInsurance, upsellVariantChange, upsellAdd };
})();
